import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { NATIVE_LANGUAGE_NAME_MAPPING } from 'shared/i18n';

const propTypes = {
  active: PropTypes.bool.isRequired,
  path: PropTypes.bool.isRequired,
  locale: PropTypes.string.isRequired,
};

const defaultProps = {};

const StorageMartLanguageOption = ({ active, path, locale }) => {
  const [query, setQuery] = useState('');
  useEffect(() => {
    if (typeof window !== 'undefined') {
      setQuery(window.location.search);
    }
  }, []);

  const href = `${path}${query}`;

  return (
    <li className="flex items-center gap-4">
      {active ? (
        <>
          <span className="md:grow font-bold">
            {NATIVE_LANGUAGE_NAME_MAPPING[locale]}
          </span>
          <i className="fa fa-fw fa-check" aria-hidden="true" />
        </>
      ) : (
        <a href={href} className="flex items-center gap-2 hovcus:no-underline hovcus:text-black text-light-text">
          <span className="md:grow hovcus:underline">
            {NATIVE_LANGUAGE_NAME_MAPPING[locale]}
          </span>
        </a>
      )
      }
    </li>
  );
};

StorageMartLanguageOption.propTypes = propTypes;
StorageMartLanguageOption.defaultProps = defaultProps;

export default StorageMartLanguageOption;
